/* =================================================================
   ROSEWOMAN MENU - Toggle Functionality
   ================================================================= */

(function() {
    'use strict';
    
    function initRosewomanMenu() {
        console.log('Initializing Rosewoman Menu...');
        
        // Get all toggle buttons
        const toggleButtons = document.querySelectorAll('.rosewoman-menu__toggle');
        
        if (!toggleButtons.length) {
            console.log('No Rosewoman menu toggle buttons found');
            return;
        }
        
        console.log('Found ' + toggleButtons.length + ' toggle buttons');
        
        // Add click handler to each toggle button
        toggleButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                console.log('Toggle button clicked');
                
                // Get the parent menu item
                const menuItem = this.closest('.rosewoman-menu__item--parent');
                
                if (!menuItem) {
                    console.log('Could not find parent menu item');
                    return;
                }
                
                // Check if currently expanded
                const isExpanded = menuItem.classList.contains('rosewoman-menu__item--expanded');
                
                console.log('Currently expanded:', isExpanded);
                
                // Close all sibling menus (accordion behavior)
                const parentMenu = menuItem.parentElement;
                if (parentMenu && parentMenu.classList.contains('rosewoman-menu--vertical')) {
                    const siblings = parentMenu.querySelectorAll('.rosewoman-menu__item--parent');
                    siblings.forEach(function(sibling) {
                        if (sibling !== menuItem) {
                            sibling.classList.remove('rosewoman-menu__item--expanded');
                            const siblingToggle = sibling.querySelector('.rosewoman-menu__toggle');
                            if (siblingToggle) {
                                siblingToggle.setAttribute('aria-expanded', 'false');
                            }
                        }
                    });
                }
                
                // Toggle this menu
                if (isExpanded) {
                    menuItem.classList.remove('rosewoman-menu__item--expanded');
                    this.setAttribute('aria-expanded', 'false');
                    console.log('Collapsed menu');
                } else {
                    menuItem.classList.add('rosewoman-menu__item--expanded');
                    this.setAttribute('aria-expanded', 'true');
                    console.log('Expanded menu');
                }
            });
            
            // Set initial aria-expanded
            button.setAttribute('aria-expanded', 'false');
        });
        
        console.log('Rosewoman Menu initialized successfully');
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRosewomanMenu);
    } else {
        initRosewomanMenu();
    }
    
    // Re-initialize when drawer opens (for dynamic content)
    document.addEventListener('drawer:opened', function() {
        console.log('Drawer opened, re-initializing menu...');
        setTimeout(initRosewomanMenu, 100);
    });
    
})();

/* ===== END ROSEWOMAN MENU JS ===== */
